<ccl-palette title="Page elements">
    <div
        class="layout-container L_filter P_session"
        [ngClass]="{
            L_filter: sharedService.catalogLayoutConfig.filterPlacement == 'left',
            T_filter: sharedService.catalogLayoutConfig.filterPlacement == 'top',
            S_filter: sharedService.catalogLayoutConfig.filterPlacement == 'slider',
            M_session: ((sharedService.catalogLayoutConfig.listType == 'magazine' && sharedService.catalogLayoutConfig.highlightedStyle == 'list') || sharedService.catalogLayoutConfig.listType == 'magazine'),
            MC_session: sharedService.catalogLayoutConfig.listType == 'magazine' && sharedService.catalogLayoutConfig.highlightedStyle == 'card',
            P_session: ((sharedService.catalogLayoutConfig.listType == 'promoted' && sharedService.catalogLayoutConfig.promotedStyle == 'list') || sharedService.catalogLayoutConfig.listType == 'promoted'),
            PC_session: sharedService.catalogLayoutConfig.listType == 'promoted' && sharedService.catalogLayoutConfig.promotedStyle == 'card',
            G_session: ((sharedService.catalogLayoutConfig.listType == 'general' && sharedService.catalogLayoutConfig.generalStyle == 'list') || sharedService.catalogLayoutConfig.listType == 'general'),
            GC_session: sharedService.catalogLayoutConfig.listType == 'general' && sharedService.catalogLayoutConfig.generalStyle == 'card'
        }"
    >
        <div
            src="img/spacer.gif"
            class="layout-navbox header"
            [ngClass]="sharedService.currentLayoutSection == 'header' ? 'active' : ''"
            (cclClick)="navigateTo('header')"
            cclTitle="Edit header"
        ></div>
        <div
            src="img/spacer.gif"
            class="layout-navbox html"
            [ngClass]="sharedService.currentLayoutSection == 'html-top' ? 'active' : ''"
            (cclClick)="navigateTo('html-top')"
            cclTitle="Edit html"
        ></div>
        <div
            src="img/spacer.gif"
            class="layout-navbox tabs"
            [ngClass]="sharedService.currentLayoutSection == 'tabs' ? 'active' : ''"
            (cclClick)="navigateTo('tabs')"
            cclTitle="Edit tabs"
        ></div>
        <div
            src="img/spacer.gif"
            class="layout-navbox filter"
            [ngClass]="sharedService.currentLayoutSection == 'filter' ? 'active' : ''"
            (cclClick)="navigateTo('filter')"
            cclTitle="Edit filter"
        ></div>
        <div
            src="img/spacer.gif"
            class="layout-navbox sessions top"
            [ngClass]="sharedService.currentLayoutSection == 'highlighted-session' ? 'active' : ''"
            (cclClick)="navigateTo('highlighted-session')"
            cclTitle="Edit highlighted session layout"
        ></div>
        <div
            src="img/spacer.gif"
            class="layout-navbox sessions mid"
            [ngClass]="sharedService.currentLayoutSection == 'promoted-session' ? 'active' : ''"
            (cclClick)="navigateTo('promoted-session')"
            cclTitle="Edit promoted session layout"
        ></div>
        <div
            src="img/spacer.gif"
            class="layout-navbox sessions bottom"
            [ngClass]="sharedService.currentLayoutSection == 'general-session' ? 'active' : ''"
            (cclClick)="navigateTo('general-session')"
            cclTitle="Edit general session layout"
        ></div>
        <div
            src="img/spacer.gif"
            class="layout-navbox html"
            [ngClass]="sharedService.currentLayoutSection == 'html-bottom' ? 'active' : ''"
            (cclClick)="navigateTo('html-bottom')"
            cclTitle="Edit html"
        ></div>
        <div
            src="img/spacer.gif"
            class="layout-navbox footer"
            [ngClass]="sharedService.currentLayoutSection == 'footer' ? 'active' : ''"
            (cclClick)="navigateTo('footer')"
            cclTitle="Edit footer"
        ></div>
        <div
            src="img/spacer.gif"
            class="layout-navbox speaker"
            [ngClass]="sharedService.currentLayoutSection == 'speaker' ? 'active' : ''"
            (cclClick)="navigateTo('speaker')"
            cclTitle="Edit speaker layout"
        ></div>
        <div
            src="img/spacer.gif"
            class="layout-navbox login navbox__bottom_border"
            [ngClass]="sharedService.currentLayoutSection == 'login' ? 'active' : ''"
            (cclClick)="navigateTo('login')"
            cclTitle="Edit Log In Screen"
        >
            <i class="fa fa-sign-out fa-lg" aria-hidden="true"></i>
            <h4>Log In Screen</h4>
        </div>
        <div
            src="img/spacer.gif"
            class="layout-navbox mysession navbox__bottom_border"
            [ngClass]="sharedService.currentLayoutSection == 'mysession' ? 'active' : ''"
            (cclClick)="navigateTo('mysession')"
            cclTitle="Edit My Sessions Drawer"
        >
            <i class="fa fa-shopping-basket fa-lg" title="Cart" aria-hidden="true"></i>
            <h4>My Sessions</h4>
        </div>
        <!-- <div
            src="img/spacer.gif" 
            class="layout-navbox sessionresources navbox__bottom_border"
            [ngClass]="sharedService.currentLayoutSection == 'sessionresources' ? 'active' : ''"
            (cclClick)="navigateTo('sessionresources')"
            cclTitle="Edit My Resources Drawer"
        >
            <i class="fa fa-download fa-lg" title="session resources" aria-hidden="true"></i>
            <h4>Session Resources</h4>
        </div> -->
        <!-- <div
            src="img/spacer.gif"
            class="layout-navbox sessionwidgets"
            [ngClass]="sharedService.currentLayoutSection == 'sessionrecommendationwidget' ? 'active' : ''"
            (cclClick)="navigateTo('sessionrecommendationwidget')"
            cclTitle="Edit Session Advisor Widgets Data"
            *ngIf="sharedService.enableSessionWidgets"
        >
            <i class="fa fa-sign-in fa-lg" title="Session Advisor Widget" aria-hidden="true"></i>
            <h4>Session Widget</h4>
        </div>  -->
        <div class="clearfix"></div>
    </div>

    <div class="s-palette__detail">
        <ccl-section-wrapper>
            <router-outlet></router-outlet>
        </ccl-section-wrapper>
    </div>
</ccl-palette>
